import React, { useEffect, useState } from 'react';
import {
  Switch,
  useHistory,
  useLocation,
  useRouteMatch,
} from 'react-router-dom';
import { AppPermissions } from '@erecruit/types';
import { useRootRoute, AuthorizedRoute } from '@erecruit/modules';
import Insight from '../App/components/InsightPortal';
import MatchSearch from '../components/MatchSearch';
import PositionRecord from '../components/PositionRecord';
import { MatchRecord } from '../components/MatchRecord';

const Matches = () => {
  const [isMountedHistory, setIsMountedRouter] = useState(false);
  const history = useHistory();
  const { pathname } = useLocation();
  const rootRoute = useRootRoute();
  const routeMatch = useRouteMatch<{ matchId: string }>();

  if (!isMountedHistory && !routeMatch.isExact) {
    if (pathname.includes('matches/position')) {
      history.push(pathname.replace('matches/position', 'position'));
    } else {
      history.push(pathname.replace('matches', 'match'));
    }
  }
  useEffect(() => {
    return history.listen(() => {
      setIsMountedRouter(true);
    });
  }, [history]);

  return (
    <>
      <MatchSearch exportPermission={AppPermissions.ExportMatches} />
      {isMountedHistory && (
        <Switch>
          <AuthorizedRoute
            permission={`${AppPermissions.ViewMatches} & ${AppPermissions.ViewMatch}`}
            exact
            path={`/matches/:id`}
            render={props => (
              <Insight referer={rootRoute}>
                <MatchRecord {...props} />
              </Insight>
            )}
          />
          <AuthorizedRoute
            permission={`${AppPermissions.ViewPositions} & ${AppPermissions.ViewPosition}`}
            path={`/matches/position/:id/:matchStatus?`}
            render={props => (
              <Insight referer={rootRoute}>
                <PositionRecord {...props} />
              </Insight>
            )}
          />
        </Switch>
      )}
    </>
  );
};

export default Matches;
